import { z } from "zod";
import { PublicEvidenceClassSchema } from "./evidence-class.js";
export const ShareableReportPrioritySchema = z.enum(["P1", "P2", "P3", "P4", "P5"]);
export const ShareablePublicProblemV1Schema = z
    .object({
    title: z.string().min(1),
    detail: z.string().min(1),
    priority: ShareableReportPrioritySchema,
    evidenceClass: PublicEvidenceClassSchema,
})
    .strict();
//# sourceMappingURL=shareable-report-fields.js.map